//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Assemblies.js";
import "../no/BasePart.js";
import "../no/Session.js";
let d=[[],[[["workset","operation"],"CreateDesignElementBuilder",{R_:{builder:"Assemblies.DesignElementBuilder"}},2,0],[["workSetPart"],"CreateOverridePartBuilder",{R_:{builder:"Assemblies.CreateOverridePartBuilder"}},1,0],[["workSetPart"],"DeleteOverridePartBuilder",{R_:{builder:"Assemblies.DeleteOverridePartBuilder"}},1,0],[["worksetPart","positioningGroup"],"CreatePositioningGroupBuilder",{R_:{builder:"Assemblies.PositioningGroupBuilder"}},2,0],[["workSetPart"],"CreateAbsolutePositionBuilder",{R_:{builder:"Assemblies.AbsolutePositionBuilder"}},1,0],[["workSetPart"],"CreateUpdateDesignElementPositionBuilder",{R_:{builder:"Assemblies.UpdateDesignElementPositionBuilder"}},1,0],[["part"],"CreateCopyDesignElementBuilder",{R_:{builder:"Assemblies.CopyDesignElementBuilder"}},1,0]],[["CollaborativeDesigns","CollaborativeDesignCollection",0]]];
SPLM.CollaborativeContentManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CollaborativeContentManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;